/**
 * Builds a router-relative path with a loginError query param for post-OAuth failure redirects.
 */
export function buildLoginErrorRedirectPath(finalPath: string, errorMessage: string): string {
  const errorParam = encodeURIComponent(errorMessage)
  const separator = finalPath.includes('?') ? '&' : '?'
  return `${finalPath}${separator}loginError=${errorParam}`
}
